import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ILabPartnerDetails } from "@/api_framework/api_modals/LabReport";

AxiosCurlirize(axios, () => {});

export const useLabPartnerDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [labPartnerDetails, setLabPartnerDetails] = useState<ILabPartnerDetails | null>(null);
  const configuration = useConfiguration();

  const execute = useCallback(
    async (labPartnerId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${LAB_REPORT?.LAB_PARTNER_DETAILS?.baseURL}${labPartnerId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setLabPartnerDetails(res.data.data);
            } else {
              setLabPartnerDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            setLabPartnerDetails(null);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        setLabPartnerDetails(null);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, labPartnerDetails };
};
